export default __webpack_public_path__ + "static/media/pago-en-efectivo.72168079.svg";